import { ApiService } from '~/services/api/api'

export interface GoogleDriveSubmissionItem {
  id: string
  name: string
  mimeType: string
  sizeBytes?: number
  isFolder: boolean
}

export interface GoogleDriveSubmissionResponse {
  batchId: string
  eligibleFiles: number
  skippedFiles: number
}

export class TestGoogleDriveSubmissionsService {
  private readonly apiService = new ApiService()

  async postGoogleDriveSubmissions(
    testId: string,
    googleAccessToken: string,
    items: GoogleDriveSubmissionItem[],
    organization: string,
  ) {
    const response = await this.apiService.post<GoogleDriveSubmissionResponse>(
      `/tests/${testId}/attempts/file-submissions/google-drive`,
      { items, organization },
      { headers: { 'X-Google-Access-Token': googleAccessToken } },
    )
    return response
  }
}
